import React, { ChangeEvent, useEffect } from 'react'
import {
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CForm,
  CFormInput,
  CRow,
} from '@coreui/react-pro'
import { useGiftOrderDetails } from './hooks'
import { setGiftOrder, submitEditGiftOrder } from './model'
import { Divider } from 'antd'

export const EditGiftOrder = () => {
  const { giftOrder, loading } = useGiftOrderDetails()
  const handleChange = (
    event: ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
  ) => {
    let value

    if (event.currentTarget.type === 'checkbox') {
      value = (event.currentTarget as HTMLInputElement).checked
    } else {
      value = event.currentTarget.value
    }

    setGiftOrder({
      ...giftOrder,
      [event.currentTarget.name]: value,
    })
  }
  const handleChangeDeliveryInfo = (
    event: ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
  ) => {
    let value

    if (event.currentTarget.type === 'checkbox') {
      value = (event.currentTarget as HTMLInputElement).checked
    } else {
      value = event.currentTarget.value
    }

    setGiftOrder({
      ...giftOrder,
      deliveryInfo: {
        ...giftOrder.deliveryInfo,
        [event.currentTarget.name]: value,
      },
    })
  }

  useEffect(() => {
    //@ts-ignore
    if (!giftOrder.costPrice) {
      setGiftOrder({
        ...giftOrder,
        ['costPrice']: giftOrder.gift.costPrice,
      })
    }
  }, [giftOrder.costPrice])

  if (loading) {
    return <div>Downloading</div>
  }

  return (
    <div>
      <CCard className="mb-4">
        <CCardHeader className="d-sm-flex justify-content-between align-items-center">
          <strong>Edit gift order {giftOrder.id}</strong>
        </CCardHeader>
        <CCardBody>
          <CForm>
            <CRow className="mb-3">
              <CCol sm={4}>
                <CFormInput
                  type="text"
                  id="shippingPrice"
                  name="shippingPrice"
                  value={giftOrder.shippingPrice}
                  onChange={handleChange}
                  label="Shipping cost"
                />
              </CCol>
              <CCol sm={4}>
                <CFormInput
                  type="text"
                  id="costPrice"
                  name="costPrice"
                  value={giftOrder.costPrice}
                  onChange={handleChange}
                  label="Cost price (USD)"
                />
              </CCol>
            </CRow>
            <Divider />
            {giftOrder.deliveryInfo && (
              <CRow>
                <div className="mt-2">
                  <span>Delivery information:</span>
                </div>
                <Divider />
                <CRow>
                  <CCol sm={4}>
                    <CFormInput
                      type="text"
                      id="first_name"
                      name="first_name"
                      value={giftOrder.deliveryInfo.first_name}
                      onChange={handleChangeDeliveryInfo}
                      label="first name"
                      readOnly={true}
                      disabled={true}
                    />
                  </CCol>
                  <CCol sm={4}>
                    <CFormInput
                      type="text"
                      id="last_name"
                      name="last_name"
                      value={giftOrder.deliveryInfo.last_name}
                      onChange={handleChangeDeliveryInfo}
                      label="last name"
                      readOnly={true}
                      disabled={true}
                    />
                  </CCol>
                  <CCol sm={4}>
                    <CFormInput
                      type="text"
                      id="contact_number"
                      name="contact_number"
                      value={giftOrder.deliveryInfo.contact_number}
                      onChange={handleChangeDeliveryInfo}
                      label="Phone"
                      readOnly={true}
                      disabled={true}
                    />
                  </CCol>
                </CRow>
                <CRow className="mt-3">
                  <CCol sm={4}>
                    <CFormInput
                      type="text"
                      id="country"
                      name="country"
                      value={giftOrder.deliveryInfo.country}
                      onChange={handleChangeDeliveryInfo}
                      label="Country"
                      readOnly={true}
                      disabled={true}
                    />
                  </CCol>
                  <CCol sm={4}>
                    <CFormInput
                      type="text"
                      id="address"
                      name="address"
                      value={giftOrder.deliveryInfo.address}
                      onChange={handleChangeDeliveryInfo}
                      label="Address"
                      readOnly={true}
                      disabled={true}
                    />
                  </CCol>
                </CRow>
              </CRow>
            )}
            <Divider />
            <CButton
              className="mb-3"
              disabled={loading}
              onClick={() => {
                submitEditGiftOrder(giftOrder)
              }}
            >
              {loading && (
                <span className="spinner-border spinner-border-sm"></span>
              )}
              Save
            </CButton>
          </CForm>
        </CCardBody>
      </CCard>
    </div>
  )
}
